import { render, staticRenderFns } from "./Rights.vue?vue&type=template&id=41751ff3&scoped=true&"
import script from "./Rights.vue?vue&type=script&lang=js&"
export * from "./Rights.vue?vue&type=script&lang=js&"
import style0 from "./Rights.vue?vue&type=style&index=0&id=41751ff3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41751ff3",
  null
  
)

export default component.exports